import PropTypes from "prop-types";
import * as React from "react";
import QuickActionTile from "../templates/quickActionTile";
import { MANAGERS_HUB } from "../../../constants/externalUrls";
import SingleLinkTile from "../templates/singleLinkTile";
import { quickActionTilesMap } from "../tilesMap";

const ManagersHubTile = ({ id }) => {
    return (
        <QuickActionTile id={id}>
            <SingleLinkTile
                link={MANAGERS_HUB}
                title={quickActionTilesMap[id].name}
                linkText={quickActionTilesMap[id].description}
            />
        </QuickActionTile>
    );
};

ManagersHubTile.propTypes = {
    id: PropTypes.string.isRequired,
};

export default ManagersHubTile;
